import { LockPercentOpenIcon } from './LockPercentOpenIcon';

/**
 * author: mocking-mike
 * id D37BC87E-8B6E-4D69-A35C-2C2EE9B85243
 * name lock-percent-open
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-percent-open.svg
 * tags
 */
export const LockRateOpenIcon = LockPercentOpenIcon;
export default LockRateOpenIcon